import React, { useState } from "react";
import { ProgressBar } from "@/components/revanche/ProgressBar";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { QCMChoiceCard } from "@/components/revanche/QCMChoiceCard";
import { WheelPicker } from "@/components/revanche/WheelPicker";
import { MaskedValue } from "@/components/revanche/MaskedValue";

const AGES = Array.from({ length: 43 }, (_, i) => i + 18); // 18..60

const Section = ({ title, children }) => (
    <div className="mb-7">
        <h3 className="font-display font-black text-white text-xl uppercase tracking-wide mb-3">
            {title}
        </h3>
        {children}
    </div>
);

const Showcase = () => {
    const [choice, setChoice] = useState("b");
    const [age, setAge] = useState(27);

    return (
        <div className="w-full max-w-[480px] mx-auto min-h-[100dvh] bg-black px-5 py-8 safe-top safe-bottom">
            <h1 className="font-display font-black text-white text-3xl uppercase tracking-wide mb-8">
                Composants
            </h1>

            <Section title="Barre de progression">
                <ProgressBar value={2} max={7} />
            </Section>

            <Section title="Carte de choix QCM">
                <div className="flex flex-col gap-3">
                    <QCMChoiceCard
                        label="Célibataire"
                        selected={choice === "a"}
                        onClick={() => setChoice("a")}
                        dataTestId="demo-qcm-a"
                    />
                    <QCMChoiceCard
                        label="En couple"
                        subtitle="Mais tu veux progresser"
                        selected={choice === "b"}
                        onClick={() => setChoice("b")}
                        dataTestId="demo-qcm-b"
                    />
                </div>
            </Section>

            <Section title="Sélecteur à molette">
                <WheelPicker
                    options={AGES}
                    value={age}
                    onChange={setAge}
                    unit="ans"
                    dataTestId="demo-wheel"
                />
            </Section>

            <Section title="Élément masqué">
                <div className="flex flex-col gap-3">
                    <MaskedValue label="Score complet" mode="blur" value="86 %" />
                    <MaskedValue
                        label="Masculinité"
                        mode="partial"
                        value="8█ %"
                        revealCount={1}
                    />
                </div>
            </Section>

            <Section title="Bouton principal">
                <PrimaryCTA dataTestId="demo-cta">Commencer mon analyse</PrimaryCTA>
            </Section>
        </div>
    );
};

export default Showcase;
